import React               from 'react';
import classnames          from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal }           from 'react-bootstrap';

import Loading             from './components/Loading';
import BomToolParse        from './components/BomToolParse';
import BomToolQuote        from './components/BomToolQuote';
import SubstitutePart      from './components/SubstitutePart';

const bom_step_section = (step) => {
  switch (step) {
    case 1:
      return BomToolParse;
    case 2:
      return BomToolQuote;
  }
};

const bom_title = (step) => {
  switch (step) {
    case 1:
      return "BOM IMPORT";
    case 2:
      return "BOM QUOTE";
  }
};


const BomStep = (props) => {
  const ComponentSection = bom_step_section(props.step);
  return(
    <div className="bom-tool-content">
      <ComponentSection {...props} />
    </div>
  )
};

export default (props) => {
  var selected_quantity = props.selected_quantity;
  const title = bom_title(props.step);
  if (props.selected_quantity === null && props.quote!== undefined && props.quote.quantities !== undefined ){
    selected_quantity = props.quote.quantities[0];
  }
  return (
    <div>
      <Modal className="bom-tool-modal" 
       show={props.show_modal} size="xl"
       onHide={props.onCloseBomSection} 
       animation={false} centered={true} 
       backdrop="static" >
        <Loading loading={props.loading} />
        <Modal.Header closeButton>
          <Modal.Title>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BomStep 
           step={props.step} 
           bom_id={props.bom_id} 
           workbook={props.workbook}
           bomParameters={props.bomParameters}
           quote={props.quote}
           totals={props.totals}
           selected_quantity={selected_quantity}
           filter={props.filter} 
           errors={props.errors}
           onClose={props.onCloseBomSection}
           onQuote={props.onQuoteBom}
           onSaveBom={props.onSaveBom}
           onChangeQuote={props.onChangeQuote}
           onChangeParameter={props.onChangeBomParameter}
           onChangeNumBoard={props.onChangeNumBoard}
           onChangePartAction = {props.onChangePartAction}
           onChangeMountingType = {props.onChangeMountingType}
           onFindSubstitutePart = {props.onFindSubstitutePart} 
           onShowPartByStatus = {props.onShowPartByStatus}
          />
          <SubstitutePart 
           bom_id={props.bom_id} 
           offer_id={props.focus_offer_id} 
           quote={props.quote}
           substitute_parts={props.substitute_parts}
           selected_quantity={selected_quantity}
           onSearchPart={props.onSearchPart}
           onSelectSubstitutePart={props.onSelectSubstitutePart}
           onSaveSubstitutePart={props.onSaveSubstitutePart}
           onCloseSubstitutePart={props.onCloseSubstitutePart}
           loading={props.loading}
           errors={props.errors}
          />
        </Modal.Body>
      </Modal>
    </div>
  )
}
